export default __webpack_public_path__ + "static/bentoSectionBg1-621562e55f98e773807004961f7f8d64.webp";